export var NAME = 'order';
export var APPLICABLE_PROMOTIONAL_CODE_BENEFITS_UPDATED = "".concat(NAME, "/APPLICABLE_PROMOTIONAL_CODE_BENEFITS_UPDATED");
export var AREA_OF_STUDY_UPDATED = "".concat(NAME, "/AREA_OF_STUDY_UPDATED");
export var DISCOUNTS_UPDATED = "".concat(NAME, "/DISCOUNTS_UPDATED");
export var DISCOUNT_ADDITION_FAILED = "".concat(NAME, "/DISCOUNT_ADDITION_FAILED");
export var DISCOUNT_ADDITION_REQUESTED = "".concat(NAME, "/DISCOUNT_ADDITION_REQUESTED");
export var DISCOUNT_REMOVAL_REQUESTED = "".concat(NAME, "/DISCOUNT_REMOVAL_REQUESTED");
export var DISCOUNT_REMOVED = "".concat(NAME, "/DISCOUNT_REMOVED");
export var DISPLAYED_MANUSCRIPTS_UPDATED = "".concat(NAME, "/DISPLAYED_MANUSCRIPTS_UPDATED");
export var DUPLICATE_ORDER_FOUND = "".concat(NAME, "/DUPLICATE_ORDER_FOUND");
export var ORDER_FORM_RESET = "".concat(NAME, "/ORDER_FORM_RESET");
export var ORDER_LOADED = "".concat(NAME, "/ORDER_LOADED");
export var ORDER_REQUESTED = "".concat(NAME, "/ORDER_REQUESTED");
export var REQUEST_ORDER_FORM_DISCOUNT_UPDATE = "".concat(NAME, "/REQUEST_ORDER_FORM_DISCOUNT_UPDATE");
export var SAVE_FAILED = "".concat(NAME, "/SAVE_FAILED");
export var SAVE_REQUESTED = "".concat(NAME, "/SAVE_REQUESTED");
export var SAVE_SUCCEEDED = "".concat(NAME, "/SAVE_SUCCEEDED");
export var SERVICE_DESCRIPTION_SET = "".concat(NAME, "/SERVICE_DESCRIPTION_SET");
export var SET_ORDER_FORM_CURRENCY = "".concat(NAME, "/SET_ORDER_FORM_CURRENCY");
export var VERY_LONG_WORD_COUNT_UPDATED = "".concat(NAME, "/VERY_LONG_WORD_COUNT_UPDATED");
export var WC_NEW_SERVICE_OPTION_REQUESTED = "".concat(NAME, "/WC_NEW_SERVICE_OPTION_REQUESTED");
export var WC_NO_SERVICE_OPTION_FOUND = "".concat(NAME, "/WC_NO_SERVICE_OPTION_FOUND");
export var WC_SERVICE_OPTION_FOUND = "".concat(NAME, "/WC_SERVICE_OPTION_FOUND");
export var REFERRAL_EMAILS_UPDATED = "".concat(NAME, "/REFERRAL_EMAILS");
export var REFERRAL_EMAIL_UPDATE_REQUESTED = "".concat(NAME, "/REFERRAL_EMAIL_UPDATE_REQUESTED");
export var REFERRAL_EMAIL_UPDATE_COMPLETED = "".concat(NAME, "/REFERRAL_EMAIL_UPDATE_COMPLETED");
export var MULTIMEDIA_GOAL = 'multimedia services';
export var REWORK_GOAL = 'rework';
export var AJE_VIP_EDITING_ID = '4e0d62df-7c35-4f53-b49b-20ad42887170';
export var AJE_PREMIUM_EDITING = '2a94a10a-16e6-11e6-8c5d-0ac3cd229553';
export var PRESUBMISSION_REVIEW = 'c0e0624a-9762-4b2e-b521-270b0c98500a';
export var SCIENTIFIC_EDITING_ID = '3029cf2b-93c4-11ea-a626-0242ac110005';
export var NPGLE_SCIENTIFIC_EDITING_ID = '6e89f27e-bd52-11e9-9cb5-2a2ae2dbcce4';
export var REWORK_QUESTION_SERVICE = '491db2d8-5c7d-11e9-9e20-12b504df345a';
export var MAXIMUM_AREA_OF_STUDY_REQUESTS = 10;
export var UNDETERMINED_AREA_OF_STUDY = {
  id: 494,
  name: 'Undetermined',
  parent: 493
};
export var GET_STARTED = '/researcher/submit/get-started';
export var DATA_TRACK_INFORMATION = {
  'e892c979-de5e-11ea-bf14-0242ac110004': {
    dataTrack: 'click',
    dataTrackAction: 'button click',
    dataTrackLabel: 'standard editing'
  },
  '2a94a10a-16e6-11e6-8c5d-0ac3cd229553': {
    dataTrack: 'click',
    dataTrackAction: 'button click',
    dataTrackLabel: 'premium editing'
  },
  '4e0d62df-7c35-4f53-b49b-20ad42887170': {
    dataTrack: 'click',
    dataTrackAction: 'button click',
    dataTrackLabel: 'vip editing'
  },
  '3029cf2b-93c4-11ea-a626-0242ac110005': {
    dataTrack: 'click',
    dataTrackAction: 'button click',
    dataTrackLabel: 'scientific editing'
  },
  '9ef86690-517c-11e9-9e20-12b504df345a': {
    dataTrack: 'click',
    dataTrackAction: 'button click',
    dataTrackLabel: 'journal recommendation'
  },
  'b8b2b6ac-4bfc-11e9-9e20-12b504df345a': {
    dataTrack: 'click',
    dataTrackAction: 'button click',
    dataTrackLabel: 'manuscript formatting'
  },
  '399d9532-2b03-11e9-9e20-12b504df345a': {
    dataTrack: 'click',
    dataTrackAction: 'button click',
    dataTrackLabel: 'figure formatting'
  },
  '39a2111d-2b03-11e9-9e20-12b504df345a': {
    dataTrack: 'click',
    dataTrackAction: 'button click',
    dataTrackLabel: 'table formatting'
  },
  'c0e0624a-9762-4b2e-b521-7b0259a080c0': {
    dataTrack: 'click',
    dataTrackAction: 'button click',
    dataTrackLabel: 'plagiarism check'
  }
};